import React, { useState, createContext } from 'react'
import { QueryClient } from '@tanstack/react-query'
import { Chapter } from 'types/data'

interface ContextProviderProps {
  children: React.ReactNode
}

export interface EpisodeVideoModalContextValue {
  showVideoModal: boolean
  selectedEpisode: Chapter | null
  onClose: () => void
  onOpen: (episode: Chapter) => void
}

export const queryClient = new QueryClient()

const EpisodeVideoModalContext =
  createContext<EpisodeVideoModalContextValue | null>(null)

export const EpisodeVideoModalContextProvider = ({
  children,
}: ContextProviderProps) => {
  const [showVideoModal, setShowVideoModal] = useState(false)
  const [selectedEpisode, setSelectedEpisode] = useState<Chapter | null>(null)

  const onClose = () => {
    setShowVideoModal(false)
  }

  const onOpen = (episode: Chapter) => {
    setSelectedEpisode(episode)
    setShowVideoModal(true)
  }

  return (
    <EpisodeVideoModalContext.Provider
      value={{
        showVideoModal,
        selectedEpisode,
        onClose,
        onOpen,
      }}
    >
      {children}
    </EpisodeVideoModalContext.Provider>
  )
}

export const useEpisodeVideoModal = () => {
  const ctx = React.useContext(EpisodeVideoModalContext)
  if (!ctx) {
    throw new Error(
      'EpisodeVideoModalContext cannot be used outside of EpisodeVideoModalContextProvider',
    )
  }
  return ctx
}
